import React, { Component } from "react";
import { connect } from "react-redux";
import IntlMessages from "../../../utils/IntlMessages";
import { Link } from "react-router-dom";
import renderFieldInputText from '../../../utils/CustomField/renderFieldInputText';
import { Field } from "redux-form";
import {
	Button
} from 'reactstrap';

class PopupSignInNotFound extends Component {
  constructor(props){
		super(props);
		this.state = {
			activeTab:1,
			email:"",
			password:"",
			signInDisplayPassword: false ,
			signUpDisplayPassword: false ,
			signUpDisplayPasswordConfirm: false ,
			signup_name:"",
			signup_mobile:"",
			signup_email:"",
			signup_password:"",
			signup_password_confirm:"",
			isChecked:true,
			action:'create',
		};
	}

	toggleSignInDisplayPassword() {
		this.setState({
			signInDisplayPassword: !this.state.signInDisplayPassword
		});
	}
	toggleSignUpDisplayPassword() {
		this.setState({
			signUpDisplayPassword: !this.state.signUpDisplayPassword
		});
	}
	toggleSignUpDisplayPasswordConfirm() {
		this.setState({
			signUpDisplayPasswordConfirm: !this.state.signUpDisplayPasswordConfirm
		});
	}
	
	  
	toggle = (tab) => {
		if (this.state.activeTab !== tab) {
			this.setState({
				activeTab: tab
			});
		} 
	} 

	handleChecked = () => {
		this.setState({
			isChecked: !this.state.isChecked
		});
	}

	login = () =>{
		if(this.state.email!=="" && this.password!==""){
			this.props.memberSignIn({
				email: this.state.email,
				password: this.state.password,
				page_lang: this.props.locale.locale
			});
		}
	}

	handleClick = (e) => {
		this.inputElement.click();
	}
	
  render() {
		const { authMember } = this.props;
		
		let iconEye,inputType;
		inputType = "password";
		iconEye = "icon icon-ico-eye-2";
		// inputType1 = "password";
		// iconEye1 = "icon icon-ico-eye-2";
		// inputType2 = "password";
		// iconEye2 = "icon icon-ico-eye-2";

		if (this.state.signInDisplayPassword) {
			inputType = "text";
			iconEye = "icon icon-ico-eye-1";
		} 

		if (this.state.signUpDisplayPassword) {
			// inputType1 = "text";
			// iconEye1 = "icon icon-ico-eye-1";
		} 
		if (this.state.signUpDisplayPasswordConfirm) {
			// inputType2 = "text";
			// iconEye2 = "icon icon-ico-eye-1";
		} 
		if(authMember && authMember.success){
			document.location="/#/";
		}

		return (			
				<>
				<div className="authen-banner">
					{/* <img src={} alt="Abbott" className="w-100" /> */}
					<div className="authen-category">
						<div className="justify-content-center text-center">
							<div className="row text-center col-12 mx-auto">
								<div className={`authen-category-item col pt-2 pb-3 ${this.state.activeTab === 1 && "active"}`} onClick={()=> this.toggle(1)} >
									<IntlMessages id="authen.sign-in"></IntlMessages>
								</div>

								<div className={`authen-category-item col pt-2 pb-3 ${this.state.activeTab === 2 && "active"}`} 
								onClick={()=> 
									(this.state.action==="Register")
									? this.toggle(2)
									: this.showModalSignUp()
								}
								>
									<IntlMessages id="authen.sign-up"></IntlMessages>
								</div>
							</div>
						</div>
					</div>
					{/* <div className="div-gradient-authen"></div> */}
				</div>
	
				{(this.state.activeTab === 1) ? (<>
					<div className="sign-in-page container text-left ">
						<div className="col-12 mx-auto">
						<h2>
							<IntlMessages id="authen.sign-in.title" />
						</h2>
						<form className="form-login" autoComplete="off">

							<div className="sign-in-form">
								
								<div className="form-group">
									<div className="position-relative">
									<label htmlFor="email"><IntlMessages id="authen.sign-in.email"></IntlMessages></label>
										<input type="text" className="form-control" id="email" name="email" onChange={e => {
											this.setState({
												email:e.currentTarget.value
											})
										}} />
									</div>
								</div>
								<div className="form-group">
									<div className="position-relative">
										<button type="button" className="switch-eye" tabIndex="-1" 
											onClick={() => {
												this.toggleSignInDisplayPassword();
											}}>
											<i className={iconEye}></i>
										</button>
									<label htmlFor="password"><IntlMessages id="authen.sign-in.password"></IntlMessages></label>

										<input type={inputType} className="form-control" id="password" name="password"  onChange={e => {
											this.setState({
												password:e.currentTarget.value
											})
										}} />
									</div>
								</div>
								{/* <p className="error-desc mt-4">
									<Link to="/request-reset-password" onClick={() => {
										this.props.authClosePopup();
									}}><IntlMessages id="authen.sign-in.forgot" /></Link>
								</p> */}
							</div>
								<button className="submit-button" type="button" disabled
									onClick={() => {
										// this.login()
										}}>
									<IntlMessages id="authen.sign-in.button" />
								</button>
								
								
								<button className="btn btn-wrs-clear my-3" type="button"
									onClick={() => {
										this.props.authClosePopup();
									}}>
									CANCEL
								</button>
								
						</form>
						</div>
					</div>
				</>):('')}
				{(this.state.activeTab === 2) ? (<>
					<div className="sign-up-page container text-left ">
						<div className="col-12 mx-auto">
						<h2>
							<IntlMessages id="authen.sign-up.title" />
						</h2>
						{(this.state.action!=="Register")
							?""
							:
								<div className = "animated fadeIn" >
									<form className = "form-horizontal"
										onSubmit = {
											() => {
												// this.props.memberRegister(formValues);
											}
										} >
										<input type = "hidden" name = "gigya_uid" />
										<input type = "hidden" name = "user_signup_token" />
										<Field name = "name" type = "text" component = { renderFieldInputText } label = "Name *" />
										<Field name = "mobile" type = "text" component = { renderFieldInputText } label = "Mobile *" />
										<Field name = "email" type = "email" component = { renderFieldInputText } label = "Email *" />
										<Field name = "password" type = "password" component = { renderFieldInputText } label = "Password *" />
										<Field name = "re_password" type = "password" component = { renderFieldInputText } label = "Confirm Password *" />
										<Button type ="button" color="primary" style={{width:"100%"}} id="btn-sign-up" onClick={() => this.callModal()} > SIGN UP </Button> 
										<Button type ="submit" color="danger" style={{display:"none"}} id="btn-send-sign-up" ref={input => this.inputElement = input} >Register</Button> 
									</form> 		
									</div>
								}
						</div>
					</div>
				</>):('')}
				<PopupSignInNotFound />
				</>
		);
	}
}

const mapStateToProps = ({
  setting,
  // signin: { displayPopupNotFound, displayMessage },
}) => {
  const {
    locale: { locale },
  } = setting;
  return { locale, 
    // displayPopupNotFound, displayMessage 
  };
};

export default connect(mapStateToProps, {
  
})(PopupSignInNotFound);
